import { getNovuInfo, NovuInfoType } from 'lib/api_ts/novuApi';
import { createContext, useState, useEffect, ReactNode, useContext } from 'react';

import { NovuProvider } from '@novu/notification-center';
import { UserContext } from './UserProvider';

export const NovuNotificationContext = createContext<NovuInfoType | undefined>(undefined);

export const NovuNotificationProvider = ({ children }: { children: ReactNode }) => {
	const [novuInfo, setNovuInfo] = useState<NovuInfoType>();
	const { myUser } = useContext(UserContext);

	useEffect(() => {
		if (!myUser?.email) return;
		(async () => {
			try {
				const novuInfoFromApi = await getNovuInfo();
				setNovuInfo(novuInfoFromApi);
			} catch (error) {
				console.error('Error fetching Novu info:', error);
			}
		})();
	}, [myUser]);

	return (
		<NovuNotificationContext.Provider value={novuInfo}>
			<NovuProvider
				subscriberId={novuInfo?.subscriberId}
				backendUrl={novuInfo?.restApi}
				applicationIdentifier={novuInfo?.applicationId}
				subscriberHash={novuInfo?.subscriberHash}
				socketUrl={novuInfo?.socketUrl}
			>
				{children}
			</NovuProvider>
		</NovuNotificationContext.Provider>
	);
};
